













































































































































































































































































import Vue from 'vue';
import {
  Component, Watch, Inject,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { ReportResource, Report } from '@/api/reports';
import { CycleResource, Cycle } from '@/api/cycles';
import { Alert, NoticeClass, Dialog } from '@kasasa/fbase-components/lib';
import { DataTableHeader } from 'vuetify';
import {
  DepositDisplayConfiguration,
  AccountClosedByStatuses, AccountDormantByStatuses,
  AccountClosedByStatusDescriptions, AccountDormantByStatusDescriptions,
  ConditionalClosedAccountSettings, ConditionalDormantAccountSettings,
  ClosedAccountSettingsResource, DormantAccountSettingsResource,
  ClosedAccountSettings, DormantAccountSettings,
  AccountSettingsConditional, OpenedAccountSettingsResource,
  OpenedAccountSettings,
} from '@/api/accountstatussettings/';
import {
  LoanAccountSettings,
  LoanDisplayConfiguration,
  LoanStatusType,
  LoanAccountSettingsResource,
  LoanDetectionSettings,
  DelinquentSettings,
  NonAccrualStatusIndicator,
  WrittenOffStatusIndicator,
  MaturedStatusIndicator,
  NonAccrualStatusDescriptions,
  WrittenOffStatusDescriptions,
  MaturedStatusDescriptions,
  NonAccrualSettings,
  WrittenOffSettings,
  MaturedSettings,
  DelinquentSettingsResource,
  MaturedSettingsResource,
  NonAccrualSettingsResource,
  WrittenOffSettingsResource,
} from '@/api/loanaccountstatussettings/';
import StatusSettingsDialog from '@/components/StatusSettingsDialog.vue';
import ReportDownloader from '@/components/ReportDownloader.vue';
import { FiConfiguration, FiConfigurationResource } from '@/api/ficonfiguration';

@Component({
  computed: mapState([
    'fiId', 'configVersion',

  ]),
  components: {
    'status-settings-dialog': StatusSettingsDialog,
    'report-downloader': ReportDownloader,
  },
})
export default class AccountStatusSettings extends Vue {
  fiId!: string;

  @Inject('ClosedAccountSettingsResource')
  closedAccountResource!: ClosedAccountSettingsResource;

  @Inject('OpenedAccountSettingsResource')
  openedAccountResource!: OpenedAccountSettingsResource;

  @Inject('DormantAccountSettingsResource')
  dormantAccountResource!: DormantAccountSettingsResource;

  @Inject('LoanAccountSettingsResource')
  loanAccountResource!: LoanAccountSettingsResource;

  @Inject('DelinquentSettingsResource')
  delinquentSettingsResource!: DelinquentSettingsResource;

  @Inject('MaturedSettingsResource')
  maturedSettingsResource!: MaturedSettingsResource;

  @Inject('NonAccrualSettingsResource')
  nonAccrualSettingsResource!: NonAccrualSettingsResource;

  @Inject('WrittenOffSettingsResource')
  writtenOffSettingsResource!: WrittenOffSettingsResource;

  @Inject('ReportResource')
  reportResource!: ReportResource;

  @Inject('CycleResource')
  cycleResource!: CycleResource;

  @Inject('FiConfigurationResource')
  fiConfigurationResource!: FiConfigurationResource;

  dormantLoading: boolean = true;

  closedLoading: boolean = true;

  openedLoading: boolean = true;

  depositsLoading: boolean = true;

  loansLoading: boolean = true;

  initialLoanLoad: boolean = true;

  loadingFiConfiguration: boolean = true;

  savingFiConfiguration: boolean = false;

  monitorUnmappedStatusCodes: boolean = false;

  fiConfigSettings: FiConfiguration | null = null;

  depositsHeaders: DataTableHeader[] = [
    {
      text: 'Status Type', width: '15rem', value: 'accountStatusType', align: 'start',
    },
    {
      text: 'Deposit Status Configuration', value: 'depositStatusConfiguration', align: 'start',
    },
    {
      text: 'Status Codes', value: 'depositStatusCodes', align: 'start',
    },
    {
      text: '', value: 'edit', width: '1rem', align: 'end',
    },
    {
      text: '', value: '', width: '1rem', align: 'end',
    },
  ];

  loanHeaders: DataTableHeader[] = [
    {
      text: 'Status Type', width: '15rem', value: 'loanStatusType', align: 'start',
    },
    {
      text: 'Loan Status Configuration', value: 'loanStatusConfiguration', align: 'start',
    },
    {
      text: 'Status Codes', value: 'loanStatusCodes', align: 'start',
    },
    {
      text: 'Product Codes', value: 'loanProductCodes', align: 'start',
    },
    {
      text: '', value: 'edit', width: '1rem', align: 'end',
    },
    {
      text: '', value: '', width: '1rem', align: 'end',
    },
  ];

  ACTIVE_STATUS_LABEL: string = 'Active (default status)';

  DORMANT_STATUS_LABEL: string = 'Dormant';

  OPENED_STATUS_LABEL: string = 'Opened';

  CLOSED_STATUS_LABEL: string = 'Closed (required)';

  dormantConfiguration!: DepositDisplayConfiguration;

  closedConfiguration!: DepositDisplayConfiguration;

  openedConfiguration!: DepositDisplayConfiguration;

  depositConfigurations: DepositDisplayConfiguration[] = [];

  closedStatusDescriptions: Map<AccountClosedByStatuses, string> = AccountClosedByStatusDescriptions;

  dormantStatusDescriptions: Map<AccountDormantByStatuses, string> = AccountDormantByStatusDescriptions;

  loanDetectionSettings: LoanDetectionSettings = { enabled: false };

  delinquentConfiguration!: LoanDisplayConfiguration;

  nonAccrualConfiguration!: LoanDisplayConfiguration;

  nonAccrualStatusDescriptions: Map<NonAccrualStatusIndicator, string> = NonAccrualStatusDescriptions;

  writtenOffConfiguration!: LoanDisplayConfiguration;

  writtenOffStatusDescriptions: Map<WrittenOffStatusIndicator, string> = WrittenOffStatusDescriptions;

  maturedConfiguration!: LoanDisplayConfiguration;

  MaturedStatusDescriptions: Map<MaturedStatusIndicator, string> = MaturedStatusDescriptions;

  loanConfigurations: LoanDisplayConfiguration[] = [];

  allDepositStatusCodes: Set<string> = new Set();

  allLoanStatusCodes: Set<string> = new Set();

  allLoanProductCodes: Set<string> = new Set();

  unmappedStatusCodeReport: string | null = null;

  downloadReportFileName: string | null = null;

  reportCycle: Cycle | null = null;

  mounted() {
    this.loadStatuses();
  }

  @Watch('configVersion')
  loadStatuses() {
    this.loadDepositStatuses();
    this.loadLoanStatuses();
    this.loadFiConfiguration();
  }

  @Watch('loanDetectionSettings.enabled')
  loadLoans() {
    if (!this.initialLoanLoad || this.loanConfigurations.length === 0) {
      this.saveLoanDetectionSettings();
    }
    this.initialLoanLoad = false;
  }

  loadDepositStatuses() {
    this.depositsLoading = true;
    this.dormantLoading = true;
    this.closedLoading = true;
    this.openedLoading = true;
    this.allDepositStatusCodes = new Set();
    this.unmappedStatusCodeReport = null;

    const dormantConfiguration: DepositDisplayConfiguration = this.emptyDormantConfiguration();
    const openedConfiguration: DepositDisplayConfiguration = this.emptyOpenedConfiguration();

    const activeConfiguration: DepositDisplayConfiguration = {
      statusType: this.ACTIVE_STATUS_LABEL,
      isStatusTypeOnly: true,
      disabled: false,
      error: false,
      indicators: null,
      accountSettings: {
        statusCodes: [] as string[],
        accountClosedBy: AccountClosedByStatuses.UNSET,
        condition: AccountSettingsConditional.UNSET,
        kind: 'active',
        active: true,
      },
    };

    const closedConfiguration: DepositDisplayConfiguration = {
      statusType: this.CLOSED_STATUS_LABEL,
      isStatusTypeOnly: false,
      disabled: false,
      error: false,
      indicators: [{
        enumValue: 'CLOSED_DATE',
        label: 'Closed Date',
        statusCodeRequired: false,
        productCodeRequired: false,
      },
      {
        enumValue: 'STATUS_CODE',
        label: 'Status Code',
        statusCodeRequired: true,
        productCodeRequired: false,
      }],
      accountSettings: {
        statusCodes: [] as string[],
        accountClosedBy: AccountClosedByStatuses.UNSET,
        condition: AccountSettingsConditional.UNSET,
        kind: 'closed',
        active: true,
      },
    };

    this.closedAccountResource.getOne(this.fiId).then((settings: ClosedAccountSettings) => {
      Object.assign(closedConfiguration.accountSettings, settings);
      if (closedConfiguration.accountSettings.statusCodes) {
        closedConfiguration.accountSettings.statusCodes.forEach(item => this.allDepositStatusCodes.add(item));
      }
      closedConfiguration.error = false;
    }).catch((error: any) => {
      if (error.response && error.response.status !== 404) {
        this.showError(error);
        closedConfiguration.error = true;
        closedConfiguration.disabled = true;
      }
    }).finally(() => {
      this.closedLoading = false;
      this.closedConfiguration = closedConfiguration;
    });

    this.openedAccountResource.getOne(this.fiId).then((settings: OpenedAccountSettings) => {
      Object.assign(openedConfiguration.accountSettings, settings);
      if (openedConfiguration.accountSettings.statusCodes) {
        openedConfiguration.accountSettings.statusCodes.forEach(item => this.allDepositStatusCodes.add(item));
      }
      openedConfiguration.error = false;
    }).catch((error: any) => {
      if (error.response && error.response.status !== 404) {
        this.showError(error);
        openedConfiguration.error = true;
        openedConfiguration.disabled = true;
      }
    }).finally(() => {
      this.openedLoading = false;
      this.openedConfiguration = openedConfiguration;
    });

    this.dormantAccountResource.getOne(this.fiId).then((settings: DormantAccountSettings) => {
      if (settings.active) {
        Object.assign(dormantConfiguration.accountSettings, settings);
        if (dormantConfiguration.accountSettings.statusCodes) {
          dormantConfiguration.accountSettings.statusCodes.forEach(item => this.allDepositStatusCodes.add(item));
        }
      } else {
        Object.assign(dormantConfiguration.accountSettings, AccountStatusSettings.emptyDormantSettings());
      }
      dormantConfiguration.error = false;
    }).catch((error: any) => {
      if (error.response && error.response.status !== 404) {
        this.showError(error);
        dormantConfiguration.error = true;
        dormantConfiguration.disabled = true;
      }
    }).finally(() => {
      this.dormantLoading = false;
      this.dormantConfiguration = dormantConfiguration;
    });

    this.depositConfigurations = [activeConfiguration, openedConfiguration, dormantConfiguration, closedConfiguration];
    this.checkForUnmappedStatusCodeReport();
  }

  @Watch('dormantLoading')
  @Watch('closedLoading')
  @Watch('openedLoading')
  updateDepositsLoading() {
    this.depositsLoading = this.dormantLoading || this.closedLoading || this.openedLoading;
  }

  onStatusSaved(saved: ConditionalClosedAccountSettings | ConditionalDormantAccountSettings | OpenedAccountSettings): void {
    switch ((saved as any).kind) {
      case 'closed': {
        const closedSettings = saved as ConditionalClosedAccountSettings;
        this.onClosedStatusSaved(closedSettings);
        break;
      }
      case 'dormant': {
        const dormantSettings = saved as ConditionalDormantAccountSettings;
        this.onDormantStatusSaved(dormantSettings);
        break;
      }
      default: {
        // Must be "opened"
        const openedSettings = (saved as OpenedAccountSettings);
        this.onOpenedStatusSaved(openedSettings);
        break;
      }
    }
    this.rebuildAllDepositStatusCodes();
  }

  rebuildAllDepositStatusCodes() {
    this.allDepositStatusCodes.clear();

    if (this.openedConfiguration.accountSettings.statusCodes) {
      this.openedConfiguration.accountSettings.statusCodes.forEach((code: string) => {
        this.allDepositStatusCodes.add(code);
      });
    }

    if (this.dormantConfiguration.accountSettings.statusCodes) {
      this.dormantConfiguration.accountSettings.statusCodes.forEach((code: string) => {
        this.allDepositStatusCodes.add(code);
      });
    }

    if (this.closedConfiguration.accountSettings.statusCodes) {
      this.closedConfiguration.accountSettings.statusCodes.forEach((code: string) => {
        this.allDepositStatusCodes.add(code);
      });
    }
  }

  deleteDormantSettings() {
    const that = this;

    const dialog = new Dialog('Confirm Deletion',
      'Are you sure you want to delete the Dormant Account Status Settings?');
    dialog.setAcceptLabel('OK')
      .setDeclineLabel('Cancel');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          that.depositsLoading = false;

          if (that.dormantConfiguration.accountSettings.statusCodes) {
            that.dormantConfiguration.accountSettings.statusCodes.forEach((code:string) => {
              that.allDepositStatusCodes.delete(code);
            });
          }

          const toSave: ConditionalDormantAccountSettings = AccountStatusSettings.emptyDormantSettings();
          Object.assign(toSave, that.dormantConfiguration.accountSettings);
          toSave.active = false;

          that.dormantAccountResource.save(that.fiId, toSave).then(
            (deletedSettings: DormantAccountSettings) => {
              that.depositsLoading = false;
              Object.assign(that.dormantConfiguration.accountSettings, AccountStatusSettings.emptyDormantSettings());
            },
          ).catch((error: any) => {
            that.setError('Unexpected error occurred.  Unable to delete dormant configuration settings.');
          }).finally(() => {
            that.depositsLoading = false;
          });
        }
      });
  }

  deleteOpenedSettings() {
    const that = this;

    const dialog = new Dialog('Confirm Deletion',
      'Are you sure you want to delete the Opened Account Status Settings?');
    dialog.setAcceptLabel('OK')
      .setDeclineLabel('Cancel');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          that.depositsLoading = false;

          if (that.openedConfiguration.accountSettings.statusCodes) {
            that.openedConfiguration.accountSettings.statusCodes.forEach((code:string) => {
              that.allDepositStatusCodes.delete(code);
            });
          }

          const toSave: OpenedAccountSettings = AccountStatusSettings.emptyOpenedSettings();
          Object.assign(toSave, that.openedConfiguration.accountSettings);
          toSave.active = false;

          that.openedAccountResource.save(that.fiId, toSave).then(
            (deletedSettings: OpenedAccountSettings) => {
              Object.assign(that.openedConfiguration.accountSettings, AccountStatusSettings.emptyOpenedSettings());
            },
          ).catch((error: any) => {
            that.setError('Unexpected error occurred.  Unable to delete opened configuration settings.');
          }).finally(() => {
            that.depositsLoading = false;
          });
        }
      });
  }

  onClosedStatusSaved(saved: ConditionalClosedAccountSettings) {
    Object.assign(this.closedConfiguration, saved);
  }

  onDormantStatusSaved(saved: ConditionalDormantAccountSettings) {
    Object.assign(this.dormantConfiguration, saved);
  }

  onOpenedStatusSaved(saved: OpenedAccountSettings) {
    Object.assign(this.openedConfiguration, saved);
  }

  translateStatus(settings: ConditionalClosedAccountSettings | ConditionalDormantAccountSettings) {
    switch (settings.kind) {
      case 'closed': {
        const closedSettings = settings as ConditionalClosedAccountSettings;
        return this.closedStatusDescriptions.get(closedSettings.accountClosedBy);
      }
      case 'dormant': {
        const dormantSettings = settings as ConditionalDormantAccountSettings;
        return this.dormantStatusDescriptions.get(dormantSettings.accountDormantBy);
      }
      default:
        // intentionally nothing to do
        return null;
    }
  }

  checkForUnmappedStatusCodeReport() {
    this.cycleResource.getActiveCycles(this.fiId).then((cycles:Cycle[]) => {
      if (cycles && cycles.length > 0) {
        this.reportCycle = cycles[0];
        this.reportResource.getReportInfos(this.fiId, cycles[0].id, 'CSV').then((reports:Report[]) => {
          reports.forEach((report:Report) => {
            if (report.filename.startsWith('kasasa_unmappedstatuscodes')) {
              this.unmappedStatusCodeReport = report.filename;
            }
          });
        }).catch((error:any) => {
          this.setError('Failed to check for unmapped status code report.');
        });
      }
    }).catch((error: any) => {
      this.setError('Failed to get cycles.');
    });
  }

  downloadReport() {
    this.downloadReportFileName = this.unmappedStatusCodeReport;
  }

  showError(error: any) {
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  static emptyDormantSettings() {
    const emptySettings: ConditionalDormantAccountSettings = {
      statusCodes: [] as string[],
      accountDormantBy: AccountDormantByStatuses.UNSET,
      condition: AccountSettingsConditional.UNSET,
      kind: 'dormant',
      active: true,
    };

    return emptySettings;
  }

  static emptyOpenedSettings() {
    const emptySettings: OpenedAccountSettings = {
      statusCodes: [] as string[],
      active: true,
    };

    return emptySettings;
  }

  emptyDormantConfiguration(): DepositDisplayConfiguration {
    const dormantConfiguration: DepositDisplayConfiguration = {
      statusType: this.DORMANT_STATUS_LABEL,
      isStatusTypeOnly: false,
      disabled: false,
      error: false,
      indicators: [{
        enumValue: 'DORMANT_DATE',
        label: 'Dormant Date',
        statusCodeRequired: false,
        productCodeRequired: false,
      },
      {
        enumValue: 'STATUS_CODE',
        label: 'Status Code',
        statusCodeRequired: true,
        productCodeRequired: false,
      }],
      accountSettings: AccountStatusSettings.emptyDormantSettings(),
    };

    return dormantConfiguration;
  }

  emptyOpenedConfiguration(): DepositDisplayConfiguration {
    const openedConfiguration: DepositDisplayConfiguration = {
      statusType: this.OPENED_STATUS_LABEL,
      isStatusTypeOnly: true,
      disabled: false,
      error: false,
      accountSettings: {
        statusCodes: [] as string[],
        kind: 'opened',
        active: true,
      },
      indicators: null,
    };
    return openedConfiguration;
  }

  static isEmptyDormantSettings(settings: DormantAccountSettings): boolean {
    return settings.accountDormantBy === AccountDormantByStatuses.UNSET;
  }

  isDeleteDormantSettingsEnabled(settings: DormantAccountSettings): boolean {
    if (this.depositsLoading) {
      return false;
    }

    if (!settings.active) {
      return false;
    }

    return !AccountStatusSettings.isEmptyDormantSettings(settings);
  }

  static isEmptyOpenedSettings(settings: OpenedAccountSettings): boolean {
    return !settings.statusCodes || settings.statusCodes.length === 0;
  }

  isDeleteOpenedSettingsEnabled(settings: OpenedAccountSettings): boolean {
    if (this.depositsLoading) {
      return false;
    }

    if (!settings.active) {
      return false;
    }

    return !AccountStatusSettings.isEmptyOpenedSettings(settings);
  }

  getLoanSettings() {
    this.loansLoading = true;
    this.loanAccountResource.getLoanSettings(this.fiId)
      .then((settings: LoanAccountSettings) => {
        this.loanDetectionSettings = settings.loanDetectionSettings;
        this.addSettingsToTable(settings);
      }).catch((error: any) => {
        this.loanDetectionSettings.enabled = false;
        this.loanConfigurations = [];
        this.loansLoading = false;
      });
  }

  saveLoanDetectionSettings() {
    this.loanAccountResource.saveLoanDetectionSettings(this.fiId, this.loanDetectionSettings)
      .then((settings: LoanDetectionSettings) => {
        this.loanDetectionSettings = settings;
        this.loadLoanStatuses();
      }).catch((error: any) => {
        this.loanDetectionSettings.enabled = false;
        this.showError('Error enabling Loan settings. If the problem persists please contact an administrator.');
      });
  }

  loadLoanStatuses() {
    this.getLoanSettings();
  }

  buildLoanStatusAndProductCodes() {
    this.allLoanStatusCodes = new Set();
    this.allLoanProductCodes = new Set();

    if (this.delinquentConfiguration.accountSettings.statusCodes) {
      this.delinquentConfiguration.accountSettings.statusCodes.forEach((statusCode:string) => { this.allLoanStatusCodes.add(statusCode); });
    }

    if (this.nonAccrualConfiguration.accountSettings.statusCodes) {
      this.nonAccrualConfiguration.accountSettings.statusCodes.forEach((statusCode:string) => { this.allLoanStatusCodes.add(statusCode); });
    }

    if ((this.nonAccrualConfiguration.accountSettings as NonAccrualSettings).productCodes) {
      (this.nonAccrualConfiguration.accountSettings as NonAccrualSettings).productCodes!.forEach((statusCode:string) => { this.allLoanProductCodes.add(statusCode); });
    }

    if (this.writtenOffConfiguration.accountSettings.statusCodes) {
      this.writtenOffConfiguration.accountSettings.statusCodes.forEach((statusCode:string) => { this.allLoanStatusCodes.add(statusCode); });
    }

    if ((this.writtenOffConfiguration.accountSettings as WrittenOffSettings).productCodes) {
      (this.writtenOffConfiguration.accountSettings as WrittenOffSettings).productCodes!.forEach((statusCode:string) => { this.allLoanProductCodes.add(statusCode); });
    }

    if (this.maturedConfiguration.accountSettings.statusCodes) {
      this.maturedConfiguration.accountSettings.statusCodes.forEach((statusCode:string) => { this.allLoanStatusCodes.add(statusCode); });
    }
  }

  addSettingsToTable(settings: LoanAccountSettings) {
    if (this.loanDetectionSettings.enabled) {
      const delinquentConfiguration: LoanDisplayConfiguration = this.getDelinquentConfigurationSettings();
      const nonAccrualConfiguration: LoanDisplayConfiguration = this.getNonAccrualConfigurationSettings();
      const writtenOffConfiguration: LoanDisplayConfiguration = this.getWrittenOffConfigurationSettings();
      const maturedConfiguration: LoanDisplayConfiguration = this.getMaturedConfigurationSettings();

      if (settings.delinquentAccountSettings !== null && settings.delinquentAccountSettings.active) {
        delinquentConfiguration.accountSettings = settings.delinquentAccountSettings;

        if (delinquentConfiguration.accountSettings.statusCodes) {
          delinquentConfiguration.accountSettings.statusCodes.forEach((statusCode:string) => { this.allLoanStatusCodes.add(statusCode); });
        }
      }
      if (settings.nonAccrualAccountSettings !== null && settings.nonAccrualAccountSettings.active) {
        nonAccrualConfiguration.accountSettings = settings.nonAccrualAccountSettings;
      }
      if (settings.writtenOffAccountSettings !== null && settings.writtenOffAccountSettings.active) {
        writtenOffConfiguration.accountSettings = settings.writtenOffAccountSettings;
      }
      if (settings.maturedAccountSettings !== null) {
        maturedConfiguration.accountSettings = settings.maturedAccountSettings;
      }

      this.delinquentConfiguration = delinquentConfiguration;
      this.nonAccrualConfiguration = nonAccrualConfiguration;
      this.writtenOffConfiguration = writtenOffConfiguration;
      this.maturedConfiguration = maturedConfiguration;

      this.loansLoading = false;
      this.loanConfigurations = [
        delinquentConfiguration,
        nonAccrualConfiguration,
        writtenOffConfiguration,
        maturedConfiguration,
      ];

      this.buildLoanStatusAndProductCodes();
    } else {
      this.loanConfigurations = [];
      this.loansLoading = false;
    }
  }

  getDelinquentConfigurationSettings = (): LoanDisplayConfiguration => {
    const delinquentConfiguration: LoanDisplayConfiguration = {
      nameDisplay: 'Delinquent',
      isStatusTypeOnly: false,
      disabled: false,
      error: false,
      indicators: null,
      kind: LoanStatusType.DELINQUENT,
      accountSettings: AccountStatusSettings.emptyDelinquentSettings(),
    };

    return delinquentConfiguration;
  }

  getNonAccrualConfigurationSettings = (): LoanDisplayConfiguration => {
    const nonAccrualConfiguration: LoanDisplayConfiguration = {
      nameDisplay: 'Non Accrual',
      isStatusTypeOnly: false,
      disabled: false,
      error: false,
      indicators: [{
        enumValue: 'STATUS_CODE',
        label: 'Status Code',
        statusCodeRequired: true,
        productCodeRequired: false,
      },
      {
        enumValue: 'PRODUCT_CODE',
        label: 'Product Code',
        statusCodeRequired: false,
        productCodeRequired: true,
      }],
      kind: LoanStatusType.NON_ACCRUAL,
      accountSettings: AccountStatusSettings.emptyNonAccrualSettings(),
    };

    return nonAccrualConfiguration;
  }

  getWrittenOffConfigurationSettings = (): LoanDisplayConfiguration => {
    const writtenOffConfiguration: LoanDisplayConfiguration = {
      nameDisplay: 'Written Off',
      isStatusTypeOnly: false,
      disabled: false,
      error: false,
      indicators: [{
        enumValue: 'WRITTEN_OFF_DATE',
        label: 'Written Off Date',
        statusCodeRequired: false,
        productCodeRequired: false,
      },
      {
        enumValue: 'STATUS_CODE',
        label: 'Status Code',
        statusCodeRequired: true,
        productCodeRequired: false,
      },
      {
        enumValue: 'PRODUCT_CODE',
        label: 'Product Code',
        statusCodeRequired: false,
        productCodeRequired: true,
      }],
      kind: LoanStatusType.WRITTEN_OFF,
      accountSettings: AccountStatusSettings.emptyWrittenOffSettings(),
    };

    return writtenOffConfiguration;
  }

  getMaturedConfigurationSettings = (): LoanDisplayConfiguration => {
    const maturedConfiguration: LoanDisplayConfiguration = {
      nameDisplay: 'Matured (required)',
      isStatusTypeOnly: false,
      disabled: false,
      error: false,
      indicators: [{
        enumValue: 'MATURED_DATE',
        label: 'Matured Date',
        statusCodeRequired: false,
        productCodeRequired: false,
      },
      {
        enumValue: 'STATUS_CODE',
        label: 'Status Code',
        statusCodeRequired: true,
        productCodeRequired: false,
      }],
      kind: LoanStatusType.MATURED,
      accountSettings: AccountStatusSettings.emptyMaturedSettings(),
    };

    return maturedConfiguration;
  }

  static emptyDelinquentSettings(): DelinquentSettings {
    return {
      statusCodes: [] as string[],
      active: false,
    };
  }

  static emptyNonAccrualSettings(): NonAccrualSettings {
    return {
      statusIndicator: NonAccrualStatusIndicator.UNSET,
      statusCodes: [] as string[],
      productCodes: [] as string[],
      active: false,
    };
  }

  static emptyWrittenOffSettings(): WrittenOffSettings {
    return {
      statusIndicator: WrittenOffStatusIndicator.UNSET,
      statusCodes: [] as string[],
      productCodes: [] as string[],
      active: false,
    };
  }

  static emptyMaturedSettings(): MaturedSettings {
    return {
      statusIndicator: MaturedStatusIndicator.UNSET,
      statusCodes: [] as string[],
    };
  }

  translateLoanStatus(item: LoanDisplayConfiguration) {
    switch (item.kind) {
      case LoanStatusType.DELINQUENT: {
        return 'Status Code';
      }
      case LoanStatusType.NON_ACCRUAL: {
        const nonAccrualSettings = item.accountSettings as NonAccrualSettings;
        return this.nonAccrualStatusDescriptions.get(nonAccrualSettings.statusIndicator);
      }
      case LoanStatusType.WRITTEN_OFF: {
        const writtenOffSettings = item.accountSettings as WrittenOffSettings;
        return this.writtenOffStatusDescriptions.get(writtenOffSettings.statusIndicator);
      }
      case LoanStatusType.MATURED: {
        const maturedSettings = item.accountSettings as MaturedSettings;
        return this.MaturedStatusDescriptions.get(maturedSettings.statusIndicator);
      }
      default:
        return null;
    }
  }

  isLoanStatusUnset(item: LoanDisplayConfiguration): boolean {
    if (this.loansLoading) {
      return false;
    }

    switch (item.kind) {
      case LoanStatusType.DELINQUENT: {
        return false;
      }
      case LoanStatusType.NON_ACCRUAL: {
        const nonAccrualSettings = item.accountSettings as NonAccrualSettings;
        return nonAccrualSettings.statusIndicator !== NonAccrualStatusIndicator.UNSET;
      }
      case LoanStatusType.WRITTEN_OFF: {
        const writtenOffSettings = item.accountSettings as WrittenOffSettings;
        return writtenOffSettings.statusIndicator !== WrittenOffStatusIndicator.UNSET;
      }
      default:
        return false;
    }
  }

  usesProductCodes = (item: LoanDisplayConfiguration): boolean => {
    if (item.kind === LoanStatusType.NON_ACCRUAL || item.kind === LoanStatusType.WRITTEN_OFF) {
      return true;
    }
    return false;
  }

  deleteDelinquentSettings() {
    const that = this;

    const dialog = this.getDialogMessage('Delinquent');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          const toSave: DelinquentSettings = AccountStatusSettings.emptyDelinquentSettings();
          Object.assign(toSave, that.delinquentConfiguration.accountSettings);
          toSave.active = false;

          if (that.delinquentConfiguration.accountSettings.statusCodes) {
            that.delinquentConfiguration.accountSettings.statusCodes.forEach((code:string) => {
              that.allLoanStatusCodes.delete(code);
            });
          }

          that.delinquentSettingsResource.save(that.fiId, toSave)
            .then((deletedSettings: DelinquentSettings) => {
              Object.assign(that.delinquentConfiguration.accountSettings, AccountStatusSettings.emptyDelinquentSettings());
            }).catch((error: any) => {
              that.setError('Unexpected error occurred.  Unable to delete delinquent configuration settings.');
            }).finally(() => {
              that.loansLoading = false;
            });
        }
      });
  }

  deleteNonAccrualSettings() {
    const that = this;

    const dialog = this.getDialogMessage('Non Accrual');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          const toSave: NonAccrualSettings = AccountStatusSettings.emptyNonAccrualSettings();
          Object.assign(toSave, that.nonAccrualConfiguration.accountSettings);
          toSave.active = false;

          if (that.nonAccrualConfiguration.accountSettings.statusCodes) {
            that.nonAccrualConfiguration.accountSettings.statusCodes.forEach((code:string) => {
              that.allLoanStatusCodes.delete(code);
            });
          }

          if (that.nonAccrualConfiguration.accountSettings.productCodes) {
            that.nonAccrualConfiguration.accountSettings.productCodes.forEach((code:string) => {
              that.allLoanProductCodes.delete(code);
            });
          }

          that.nonAccrualSettingsResource.save(that.fiId, toSave)
            .then((deletedSettings: NonAccrualSettings) => {
              Object.assign(that.nonAccrualConfiguration.accountSettings, AccountStatusSettings.emptyNonAccrualSettings());
            }).catch((error: any) => {
              that.setError('Unexpected error occurred.  Unable to delete non accrual configuration settings.');
            }).finally(() => {
              that.loansLoading = false;
            });
        }
      });
  }

  deleteWrittenOffSettings() {
    const that = this;

    const dialog = this.getDialogMessage('Written Off');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          const toSave: WrittenOffSettings = AccountStatusSettings.emptyWrittenOffSettings();
          Object.assign(toSave, that.writtenOffConfiguration.accountSettings);
          toSave.active = false;

          if (that.writtenOffConfiguration.accountSettings.statusCodes) {
            that.writtenOffConfiguration.accountSettings.statusCodes.forEach((code:string) => {
              that.allLoanStatusCodes.delete(code);
            });
          }

          if (that.writtenOffConfiguration.accountSettings.productCodes) {
            that.writtenOffConfiguration.accountSettings.productCodes.forEach((code:string) => {
              that.allLoanProductCodes.delete(code);
            });
          }

          that.writtenOffSettingsResource.save(that.fiId, toSave)
            .then((deletedSettings: WrittenOffSettings) => {
              Object.assign(that.writtenOffConfiguration.accountSettings, AccountStatusSettings.emptyWrittenOffSettings());
            }).catch((error: any) => {
              that.setError('Unexpected error occurred.  Unable to delete written off configuration settings.');
            }).finally(() => {
              that.loansLoading = false;
            });
        }
      });
  }

  loadFiConfiguration() {
    this.loadingFiConfiguration = true;
    this.fiConfigSettings = null;
    this.fiConfigurationResource.getFiConfiguration(parseInt(this.fiId, 10)).then((configuration:FiConfiguration) => {
      this.monitorUnmappedStatusCodes = configuration.unmappedStatusCodeMonitoring!;
      this.fiConfigSettings = configuration;
    }).catch((error: any) => {
      this.showError(error);
    }).finally(() => {
      this.loadingFiConfiguration = false;
    });
  }

  monitorUnmappedToggle() {
    this.fiConfigSettings!.unmappedStatusCodeMonitoring = this.monitorUnmappedStatusCodes;
    this.savingFiConfiguration = true;
    this.fiConfigurationResource.updateFiConfiguration(parseInt(this.fiId, 10), this.fiConfigSettings!).catch((error: any) => {
      this.showError(error);
    }).finally(() => {
      this.savingFiConfiguration = false;
    });
  }

  getDialogMessage = (settingName: string): Dialog => {
    const dialog = new Dialog('Confirm Deletion',
      `Are you sure you want to delete the ${settingName} Account Status Settings?`);
    dialog.setAcceptLabel('OK').setDeclineLabel('Cancel');

    return dialog;
  }
}
